import { useTranslation } from "react-i18next";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import type { CompanyFormData } from "./company-form-types";

interface CompanyEmailSectionProps {
	form: CompanyFormData;
	setForm: React.Dispatch<React.SetStateAction<CompanyFormData>>;
}

export function CompanyEmailSection({
	form,
	setForm,
}: CompanyEmailSectionProps) {
	const { t } = useTranslation();

	return (
		<div className="flex flex-col gap-3">
			<p className="text-sm font-medium text-muted-foreground">
				{t("settings.company.emailConfig")}
			</p>
			<div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
				<div className="grid gap-2">
					<Label htmlFor="email-host">{t("settings.company.emailHost")}</Label>
					<Input
						id="email-host"
						value={form.email_host}
						onChange={(e) =>
							setForm((f) => ({ ...f, email_host: e.target.value }))
						}
					/>
				</div>
				<div className="grid gap-2">
					<Label htmlFor="email-port">{t("settings.company.emailPort")}</Label>
					<Input
						id="email-port"
						type="number"
						value={form.email_port}
						onChange={(e) =>
							setForm((f) => ({ ...f, email_port: Number(e.target.value) }))
						}
					/>
				</div>
				<div className="grid gap-2">
					<Label htmlFor="email-username">
						{t("settings.company.emailUser")}
					</Label>
					<Input
						id="email-username"
						value={form.email_username}
						onChange={(e) =>
							setForm((f) => ({ ...f, email_username: e.target.value }))
						}
					/>
				</div>
				<div className="grid gap-2">
					<Label htmlFor="email-password">
						{t("settings.company.emailPassword")}
					</Label>
					<Input
						id="email-password"
						type="password"
						value={form.email_password}
						onChange={(e) =>
							setForm((f) => ({ ...f, email_password: e.target.value }))
						}
					/>
				</div>
				<div className="sm:col-span-2 grid gap-2">
					<Label htmlFor="email-from">{t("settings.company.emailFrom")}</Label>
					<Input
						id="email-from"
						type="email"
						value={form.email_from_email}
						onChange={(e) =>
							setForm((f) => ({ ...f, email_from_email: e.target.value }))
						}
					/>
				</div>
			</div>
		</div>
	);
}
